export default __webpack_public_path__ + "static/media/cross_gray.f3c3202a.svg";